import { render, staticRenderFns } from "./SupervisionInfo.vue?vue&type=template&id=01391e9e&scoped=true&"
import script from "./SupervisionInfo.vue?vue&type=script&lang=ts&"
export * from "./SupervisionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SupervisionInfo.vue?vue&type=style&index=0&id=01391e9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01391e9e",
  null
  
)

export default component.exports